/* eslint-disable */

import React, { useEffect } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { Page } from '../../components/atoms/layout/Page';
import { PageBody } from '../../components/atoms/layout/PageBody';
import { SurveyHeader } from '../../components/molecules/surveys/SurveyHeader';
import { SurveySubmitButton } from '../../components/molecules/surveys/SurveySubmitButton';
import { WithdrawalSurveyPageState } from '../surveys/states/WithdrawalSurveyPageState';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { CardSelectInput, CardStringInput } from '../../../commonv3/components/atoms/forms/card/CardInput';
import { QuestionCard } from '../surveys/QuestionCard';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { usePlanPaneState } from '../../components/organisms/mypage/states/PlanPaneState';
import { restrictAccessForUser } from '../../../commonv3/hooks/restrictAccessForUser';
import { willChangePlan } from '../../components/organisms/mypage/PlansPane';
import { V3Routes } from '../../routes';
import './withdrawalSurveyPage.module.scss';

export const WithdrawalSurveyShowPage = observer(() => {
  restrictAccessForUser();
  useNavigation(NavigationSpecs.none());

  const { pageState } = useLocalStore(() => ({
    pageState: new WithdrawalSurveyPageState(),
  }));

  useEffect(() => {
    pageState.init();
  }, []);

  const planState = usePlanPaneState();
  const {
    slackName,
    lineName,
    effectiveAt,
    submit,
    submitState: { submitting },
    success,
  } = pageState;

  const { initialized, survey, parameterParseError, questions, getQuestionStateFor } = pageState.surveyState;
  const hasPlanChangeSchedule = willChangePlan(planState.membershipSummaries);
  if (!initialized || !planState.initialized) {
    return <LoaderRow />;
  }
  if (hasPlanChangeSchedule) {
    GlobalStatesV3.routing.push(V3Routes.home());
  }

  const currentUser = GlobalStatesV3.currentUser;
  const withdrawalApplicableDates = currentUser.currentUser.withdrawal_applicable_dates;
  const withdrawalApplicableOptions: { value: any; label: any }[] = withdrawalApplicableDates.map((applicableDate) => ({
    value: applicableDate,
    label: applicableDate,
  }));
  const WithdrawalFormCount = 3;

  if (survey.isNotFound()) {
    return <NotFoundPage entityType="退会申請フォーム" />;
  }
  if (parameterParseError) {
    return <NotFoundPage entityType="退会申請フォーム" />;
  }

  const totalCount = questions.length + WithdrawalFormCount;
  return (
    <Page id="withdrawal-survey-page" styleName="withdrawal-survey-page">
      <PageBody>
        <SurveyHeader surveyName="退会申請フォーム" />
        <CardStringInput
          id="slack-name"
          questionNumber={1}
          totalQuestions={totalCount}
          required={true}
          sentence="slackのご登録名を入力してください"
          subSentence={
            <span>
              ※現在シーライクスのデザインTA・マーケティングTA・ブランディングTA・ライフコーチのいずれかに該当する方は、登録名の前に「※」と入力してください
              <br />
              例）※SHEちゃん
              <br />
            </span>
          }
          placeholder="山田花子"
          state={slackName}
        />
        <CardStringInput
          id="line-name"
          questionNumber={2}
          totalQuestions={totalCount}
          required={true}
          sentence="LINEのご登録名を入力してください"
          placeholder="山田花子"
          state={lineName}
        />
        <CardSelectInput
          id="effective-at"
          questionNumber={3}
          totalQuestions={totalCount}
          required={true}
          sentence="退会希望日を選択してください"
          placeholder="日付を選択してください"
          options={withdrawalApplicableOptions}
          state={effectiveAt}
          serializer={(v) => v}
          deserializer={(v) => v}
        />
        {questions.map((q, index) => {
          const questionState = getQuestionStateFor(q.survey_question_id);
          const questionNumber = index + 1 + WithdrawalFormCount;
          const totalQuestions = questions.length + WithdrawalFormCount;
          return (
            <QuestionCard
              key={q.id}
              questionNumber={questionNumber}
              totalQuestions={totalQuestions}
              question={q.survey_question}
              questionState={questionState}
            />
          );
        })}
        <SurveySubmitButton
          id="withdrawal-submit-button"
          loading={submitting}
          disabled={false}
          onClick={submit}
          success={success}
        >
          {success ? 'ありがとうございました！' : '退会を申請する'}
        </SurveySubmitButton>
      </PageBody>
    </Page>
  );
});
